export const fineGrainedPermissionsKeys = {
  EMPLOYEE: {
    BULKUPLOAD: {
      module: "employee",
      action: "employee-bulk",
    },
    ADDNEW: {
      module: "employee",
      action: "add",
    },
    DETAILS: {
      module: "employee",
      action: "details",
    },
    HIERARCHY: {
      module: "employee",
      action: "hierarchy/upper",
    },
    EDIT: {
      module: "employee",
      action: "edit",
    },
    "INACTIVE/ACTIVE": {
      module: "employee",
      action: "edit",
    },
  },
  PRODUCT: {
    ADD: {
      module: "product",
      action: "add",
    },
    DETAILS: {
      module: "product",
      action: "details",
    },
    GETPRODUCTPRICE: {
      module: "product",
      action: "get-product-price",
    },
    "PRICE/ADD": {
      module: "product",
      action: "price/add",
    },
    POGENERATION: {
      module: "product",
      action: "po-generation",
    },
    PRODUCTVISIBILITY: {
      module: "product",
      action: "region/visibility",
    },
    "INACTIVE/ACTIVE": {
      module: "product",
      action: "edit",
    },
    EDIT: {
      module: "product",
      action: "edit",
    },
  },
  COUNTER: {
    BULKUPLOAD: {
      module: "counter",
      action: "counter-bulk",
    },
    ADDNEW: {
      module: "counter",
      action: "add",
    },
    BLOCK: {
      module: "counter",
      action: "block",
    },
    REVOKE: {
      module: "counter",
      action: "revoke",
    },
    EDITCOUNTER: {
      module: "counter",
      action: "edit",
    },
    MERGE: {
      module: "counter",
      action: "merge",
    },
    INACTIVE: {
      module: "counter",
      action: "deactivate",
    },
    DETAILS: {
      module: "counter",
      action: "details",
    },
    EDITLOCATION: {
      module: "counter",
      action: "location/edit",
    },
    DELETELOCATION: {
      module: "counter",
      action: "location/delete",
    },
    COMPANIES: {
      module: "counter",
      action: "companylink",
    },
    ADDCOMPANY: {
      module: "counter",
      action: "company/add",
    },
    BLOCKCOMPANY: { module: "counter", action: "company/block" },
    DEACTIVATECOMPANY: {
      module: "counter",
      action: "company/deactivate",
    },
    DIVISIONBLOCK: {
      module: "counter",
      action: "division/block",
    },
    DEACTIVATEDIVISION: {
      module: "counter",
      action: "deactivate/division",
    },
    ADDDIVISION: {
      module: "counter",
      action: "division/add",
    },
    EDITDIVISION: {
      module: "counter",
      action: "division/edit",
    },
    DIVISIONVALUECAP: {
      module: "counter",
      action: "value-cap",
    },
    DIVISIONADDVALUECAP: {
      module: "counter",
      action: "ordercap/add",
    },
    DELEGATESVIEW: {
      module: "counter",
      action: "delegate",
    },
    DELEGATESADD: {
      module: "counter",
      action: "delegate/add",
    },
    PRODUCTSVIEW: {
      module: "counter",
      action: "product",
    },
    PRODUCTSADD: {
      module: "counter",
      action: "product/add",
    },
    PRODUCTSDELETE: {
      module: "counter",
      action: "product/delete",
    },
    PRICEIDENTIFIEREXEMPT: { module: "counter", action: "product/priceidentifier-exempt" },
    STOCKISTSVIEW: {
      module: "counter",
      action: "stockist-link",
    },
    STOCKISTSADD: {
      module: "counter",
      action: "stockist/add",
    },
    "STOCKISTSINACTIVE/ACTIVE/DEFAULT": {
      module: "counter",
      action: "stockist/active-inactive",
    },
  },
  STOCKIST: {
    DETAILS: {
      module: "stockist",
      action: "details",
    },
    ADD: {
      module: "stockist",
      action: "add",
    },
    "EDIT/ACTIVE/INACTIVE": {
      module: "stockist",
      action: "edit",
    },
    ADDCOMPANY: {
      module: "stockist",
      action: "company/add",
    },
    "EDIT/ACTIVE/INACTIVECOMPANY": { module: "stockist", action: "company/edit" },
  },
  CRA: {
    ADDNEW: {
      module: "cda",
      action: "add",
    },
    PENDING: {
      module: "cda",
      action: "counter/request",
    },
    "ACCEPT/REJECT": {
      module: "cda",
      action: "counter/request/status/update",
    },
    APPROVEDBYME: {
      module: "cda",
      action: "counter/request",
    },
  },
  PRA: {
    DETAILS_ALL: { module: "productrequest", action: "details/all" },
    DRAFT: { module: "productrequest", action: "details" },
    DETAILS: { module: "productrequest", action: "details" },
    HIERARCHY: { module: "productrequest", action: "hierarchy" },
    VIEWREMARKS: { module: "productrequest", action: "request-comment" },
    ADDREMARKS: { module: "productrequest", action: "request-comment" },
    EDIT: { module: "productrequest", action: "edit" },
    DELETE: { module: "productrequest", action: "delete" },
    APPROVE: { module: "productrequest", action: "approve" },
    REJECT: { module: "productrequest", action: "reject" },
  },
  ORDER: {
    DETAILS_ALL: {
      module: "order",
      action: "details_all",
    },
    FUID: {
      module: "order",
      action: "fuids",
    },
    INVOICES: {
      module: "order",
      action: "fuids",
    },
    VIEWHIERARCHY: {
      module: "order",
      action: "hierarchy",
    },
    VIEWREMARKS: {
      module: "order",
      action: "remarks",
    },
    ADDREMARKS: {
      module: "order",
      action: "remarks",
    },
    SENDEMAIL: {
      module: "order",
      action: "novu",
    },
    UPDATEORDERTYPE: {
      module: "order",
      action: "update-order-type",
    },
    UPDATESTOCKIST: {
      module: "order",
      action: "replace-stockist",
    },
    UPDATECASHDISCOUNT: {
      module: "order",
      action: "update-cash-discount",
    },
    UPDATEORDERSTATUS: {
      module: "order",
      action: "update-order-status",
    },
    UPDATECOUNTERLOCATION: { module: "order", action: "location-shift" },
    ORDERAPPROVE: {
      module: "order",
      action: "approve",
    },
    ORDERREJECT: {
      module: "order",
      action: "reject",
    },
    ORDERINITIATE: {
      module: "order",
      action: "/",
    },
  },
  INVOICE: {
    ENTRY: {
      module: "invoice",
      action: "stockist_attachment/all",
    },
    APPROVAL: {
      module: "invoice",
      action: "stockist_attachment/all",
    },
    "VIEW DETAILS": {
      module: "invoice",
      action: "stockist_attachment/details",
    },
    REASSIGN: {
      module: "invoice",
      action: "stockist_attachment/reassign",
    },
    "PUT ON HOLD": {
      module: "invoice",
      action: "stockist_attachment/hold",
    },
    REJECT: {
      module: "invoice",
      action: "stockist_attachment/reject",
    },
    ESCALATE: {
      module: "invoice",
      action: "stockist_attachment/escalate",
    },
    "SETPRIORITY/REMOVEPRIORITY": {
      module: "invoice",
      action: "stockist_attachment/set-priority",
    },
    VIEWREMARKS: {
      module: "invoice",
      action: "remarks",
    },
    ADDREMARKS: {
      module: "invoice",
      action: "remark",
    },
    UPDATEINVOICESTATUS: {
      module: "invoice",
      action: "status-update",
    },
    SUBMITINVOICE: {
      module: "invoice",
      action: "add",
    },
    "UPDATE/APPROVEINVOICE": {
      module: "invoice",
      action: "edit",
    },
    CONFIRMINVOICE: {
      module: "invoice",
      action: "entry",
    },
    REVERTINVOICE: {
      module: "invoice",
      action: "“revert",
    },
    REMOVEINVOICE: {
      module: "invoice",
      action: "“recall",
    },
  },
};
